import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function FeatureExhibitor() {
  return <section className="w-full border-b border-white/[0.06]" style={{
    backgroundColor: '#09090B'
  }} data-id="element-230">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28" data-id="element-231">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-232">
          {/* Visual — Left */}
          <div className="order-2 lg:order-1" data-id="element-233">
            <div className="bg-white/[0.04] border border-white/[0.08] rounded-2xl p-6" data-id="element-234">
              {/* Company header */}
              <div className="bg-white/[0.06] rounded-lg p-4 mb-4 flex items-center gap-4" data-id="element-235">
                <div className="w-12 h-12 rounded-lg bg-blue-500/20 border border-blue-500/20 flex-shrink-0" data-id="element-236" />
                <div className="flex-1 space-y-2" data-id="element-237">
                  <div className="bg-white/[0.10] h-3 rounded w-1/2" data-id="element-238" />
                  <div className="bg-white/[0.06] h-2 rounded w-3/4" data-id="element-239" />
                </div>
              </div>

              {/* Staff cards row */}
              <div className="grid grid-cols-3 gap-3 mb-4" data-id="element-240">
                <div className="bg-white/[0.06] rounded-lg p-3 text-center" data-id="element-241">
                  <div className="w-8 h-8 rounded-full bg-purple-500/20 mx-auto mb-2" data-id="element-242" />
                  <div className="bg-white/[0.08] h-1.5 rounded w-3/4 mx-auto mb-1" data-id="element-243" />
                  <div className="bg-white/[0.06] h-1 rounded w-1/2 mx-auto" data-id="element-244" />
                </div>
                <div className="bg-white/[0.06] rounded-lg p-3 text-center" data-id="element-245">
                  <div className="w-8 h-8 rounded-full bg-cyan-500/20 mx-auto mb-2" data-id="element-246" />
                  <div className="bg-white/[0.08] h-1.5 rounded w-3/4 mx-auto mb-1" data-id="element-247" />
                  <div className="bg-white/[0.06] h-1 rounded w-1/2 mx-auto" data-id="element-248" />
                </div>
                <div className="bg-white/[0.06] rounded-lg p-3 text-center" data-id="element-249">
                  <div className="w-8 h-8 rounded-full bg-emerald-500/20 mx-auto mb-2" data-id="element-250" />
                  <div className="bg-white/[0.08] h-1.5 rounded w-3/4 mx-auto mb-1" data-id="element-251" />
                  <div className="bg-white/[0.06] h-1 rounded w-1/2 mx-auto" data-id="element-252" />
                </div>
              </div>

              {/* Scan badge CTA */}
              <div className="bg-blue-500/20 border border-blue-500/30 rounded-lg p-3 text-center" data-id="element-253">
                <p className="text-blue-400 text-xs font-mono font-medium" data-id="element-254">
                  Scanner un badge
                </p>
              </div>
            </div>
          </div>

          {/* Text — Right */}
          <div className="order-1 lg:order-2" data-id="element-255">
            <p className="text-xs uppercase tracking-wider font-mono text-blue-400" data-id="element-256">
              Hub Exposants &amp; Partenaires
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-white mt-4 leading-tight font-heading" data-id="element-257">
              Chaque partenaire a une présence. Chaque partenaire obtient des
              résultats mesurables.
            </h2>
            <div className="mt-8 space-y-5" data-id="element-258">
              <div className="flex items-start gap-3" data-id="element-259">
                <CheckCircle2 className="h-5 w-5 text-blue-400 mt-0.5 flex-shrink-0" data-id="element-260" />
                <p className="text-white/70 text-sm leading-relaxed" data-id="element-261">
                  Pages profil exposant dédiées avec visibilité égale pour tous
                  les partenaires — pas de classement payant
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-262">
                <CheckCircle2 className="h-5 w-5 text-blue-400 mt-0.5 flex-shrink-0" data-id="element-263" />
                <p className="text-white/70 text-sm leading-relaxed" data-id="element-264">
                  Profils staff liés par stand avec listings produits et
                  services
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-265">
                <CheckCircle2 className="h-5 w-5 text-blue-400 mt-0.5 flex-shrink-0" data-id="element-266" />
                <p className="text-white/70 text-sm leading-relaxed" data-id="element-267">
                  Capture de leads : scannez un badge participant, capturez le
                  profil contact complet instantanément
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-268">
                <CheckCircle2 className="h-5 w-5 text-blue-400 mt-0.5 flex-shrink-0" data-id="element-269" />
                <p className="text-white/70 text-sm leading-relaxed" data-id="element-270">
                  Liste de leads exportable par exposant, livrée à la clôture de
                  l'événement
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}